import { render } from "./ApprovalQueueRow.vue?vue&type=template&id=227ea8b1&scoped=true"
import script from "./ApprovalQueueRow.vue?vue&type=script&lang=js"
export * from "./ApprovalQueueRow.vue?vue&type=script&lang=js"

import "./ApprovalQueueRow.vue?vue&type=style&index=0&id=227ea8b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227ea8b1"]])

export default __exports__